import { useEffect, useState } from 'react'
import './App.css'

function Friend() {
    const [friendEmail, setFriendEmail] = useState('')
    const [friend, setFriend] = useState('')
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [date, setDate] = useState(new Date())
    const [points, setPoints] = useState(1000)

    const pay = (e) => {
        e.preventDefault()
        const url = 'https://alsfund.ru/wp-admin/admin-ajax.php'
        let widget = new window.cp.CloudPayments()

        widget.pay(
            'charge',
            {
                publicId: 'pk_1e2e9e9c7d2597ea21d09f32340ff',
                description: '+ в карму',
                amount: parseInt(points),
                currency: 'RUB',
                email: email,
                skin: 'mini',
            },
            {
                onComplete: async function (paymentResult, options) {
                    let data = new FormData()
                    
                    friendEmail && data.append('friendEmail', friendEmail)
                    friend && data.append('friend', friend)
                    name && data.append('name', name)
                    email && data.append('email', email)
                    date && data.append('date', date)
                    points && data.append('points', points)
                    data.append('action', 'send_karma_email')
                    data.append('target', 'friend')

                    if (!paymentResult.success) {
                        data.append('fail', 'true')
                    }

                    fetch(url, {
                        method: 'POST',
                        body: data,
                    }).then(() => {
                        widget = null
                        data = null
                    })


                },
            }
        )
    }

    return (
        <div className="App">
            <div className="main-block-bg alternate"></div>
            <div className="main-block">
                <div className="main-caption">
                    <div className="plus">+</div>
                    <div className="main-text">
                        <span className="points">{points}</span>
                        <span className="text-karma">В КАРМУ</span>
                    </div>
                </div>
                <div className="form-block">
                    <form onSubmit={pay}>
                        <div className="form-block">
                            <label>Имя друга</label>
                            <input
                                type="text"
                                name="friend-name"
                                required
                                placeholder="Кто получит открытку"
                                value={friend}
                                onChange={(e) => setFriend(e.target.value)}
                            ></input>
                        </div>
                        <div className="form-block">
                            <label>Электронная почта друга</label>
                            <input
                                type="email"
                                name="friend-email"
                                required
                                placeholder="Куда отправить открытку"
                                value={friendEmail}
                                onChange={(e) => setFriendEmail(e.target.value)}
                            ></input>
                        </div>
                        <div className="form-block">
                            <label>Ваше имя</label>
                            <input
                                type="text"
                                name="gifter-name"
                                required
                                placeholder="Или другое слово, по которому вас узнают"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            ></input>
                        </div>
                        <div className="form-block">
                            <label>Ваша электронная почта</label>
                            <input
                                type="email"
                                name="gifter-email"
                                required
                                placeholder="Сюда мы пришлем подтверждение"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            ></input>
                        </div>
                        <div className="form-block">
                            <label>Дата отправки сертификата</label>
                            <input
                                type="date"
                                required
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                                name="date-gift"
                            ></input>
                        </div>
                        <div className="form-block">
                            <label>Сумма плюсов</label>
                            <input
                                className="red-input"
                                required
                                onChange={(e) => setPoints(e.target.value)}
                                name="points"
                                type="number"
                                placeholder="Сумма плюсов"
                                value={points}
                            ></input>
                        </div>
                        <button>Подарить + в карму</button>

                        <div className="policy">
                            Нажимая на кнопку, я соглашаюсь на
                            <a
                                target="_blank"
                                href="https://alsfund.ru/wp-content/uploads/2022/01/Politika-obrabotki-personalnyih-dannyih_alsfund.pdf"
                            >
                                обработку персональных данных
                            </a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
export default Friend
